
const FETCH_HOME_NEWS="FETCH_HOME_NEWS";
const FETCH_HOME_TECH_FINANCE="FETCH_HOME_TECH_FINANCE";
const FETCH_PARTNERS="FETCH_PARTNERS";
const FETCH_CAROUSEL_DATA="FETCH_CAROUSEL_DATA";

const ActionType={
    FETCH_HOME_NEWS,
    FETCH_HOME_TECH_FINANCE,
    FETCH_PARTNERS,
    FETCH_CAROUSEL_DATA
}

export default ActionType;